import React from "react"
import Layout from "../components/Layout"

const About = () => (
  <Layout>
    <h2>About me!</h2>
    <br />
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae consequatur
      ea dignissimos, tenetur maxime vel magni voluptatibus, perferendis
      cupiditate culpa quos obcaecati sint consectetur nam incidunt repellendus
      alias cum impedit? Necessitatibus
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae consequatur
      ea dignissimos, tenetur maxime vel magni voluptatibus, perferendis
      cupiditate culpa quos obcaecati sint consectetur nam incidunt repellendus
      alias cum impedit? Necessitatibus, aperiam voluptates minima soluta
      dolorem repudiandae accusamus sequi vero nobis veritatis accusantium
      facilis culpa iure, repellat ducimus temporibus dolorum ipsam dolores
      voluptatibus repellendus eligendi porro quidem aut. Voluptas, vero. Ea,
      maxime officiis voluptate soluta perspiciatis consectetur itaque
      necessitatibus cupiditate amet esse beatae rerum et ducimus sit. Rerum
      dolor accusantium ullam voluptatum ipsum ducimus laborum laudantium, autem
      quos quam sunt.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae consequatur
      ea dignissimos, tenetur maxime vel magni voluptatibus, perferendis
      cupiditate culpa quos obcaecati sint consectetur nam incidunt repellendus
      alias cum impedit? Necessitatibus, aperiam voluptates minima soluta
      dolorem repudiandae accusamus sequi vero nobis veritatis accusantium
      facilis culpa iure, repellat ducimus temporibus dolorum ipsam dolores
      voluptatibus repellendus eligendi porro quidem aut. Voluptas, vero. Ea,
      maxime officiis voluptate soluta perspiciatis consectetur itaque
      necessitatibus cupiditate amet esse beatae rerum et ducimus sit. Rerum
      dolor accusantium ullam voluptatum ipsum ducimus laborum laudantium, autem
      quos quam sunt. Libero accusantium id ullam ab expedita fugiat error
      repellendus impedit, ipsum adipisci facere omnis eveniet. Fugit molestias
      impedit ea mollitia doloremque, amet perspiciatis consequuntur eveniet
      iste natus modi commodi veritatis. Nostrum dolorem, nihil quos mollitia
      non odit quis iure repellendus alias voluptatibus labore quia saepe
      aliquam voluptatem voluptate eaque vero nam quaerat nisi rerum aspernatur.
      Laudantium assumenda tenetur
    </p>
  </Layout>
)

export default About
